<template>
  <div>
    <xmHeader :hasPc="hasPc" :index="2"></xmHeader>
    <dynamicPcList v-if="hasPc"></dynamicPcList>
    <dynamicMobileList v-else></dynamicMobileList>
    <xmFooter :hasPc="hasPc"></xmFooter>
  </div>
</template>

<script>
import platformUtils from "@/utils/platformUtils";
import xmHeader from "../../components/xmHeader/xmHeader";
import xmFooter from "../../components/xmFooter/xmFooter";
export default {
  name: "index",
  provide: {
    showbackHeader: true,
  },
  components: {
    xmHeader,
    xmFooter,
    dynamicPcList: (resolve) => {
      require(["./platform/dynamicPcList.vue"], resolve);
    },
    dynamicMobileList: (resolve) => {
      require(["./platform/dynamicMobileList.vue"], resolve);
    },
  },
  data() {
    return {
      hasPc: false,
    };
  },
  mounted() {
    platformUtils.getPcPlatform((hasPc) => {
      this.hasPc = hasPc;
    });
  },
};
</script>

<style>
</style>